/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Edit/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Actions from './Actions/index'
import DraftTag from './DraftTag/index'
import React from 'react'
import RegenerateLetterModal from './RegenerateLetterModal/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Edit({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Actions/Action/Letter/Edit"
  
}) {
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let actionDocumentTreeNodeNameValueData = fromData.useDataFormat({ viewPath,
context: 'action',
path: 'document_tree_node.name',
format: fromFormat.removeFileExtension,
})
  return (<React.Fragment
>
<div
  data-testid="Edit.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Edit.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 text="Letter"
/>
</div>
<div
  data-testid="Edit.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-1-9u9G': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="action.document_tree_node.name"
 format="/Data/format.js removeFileExtension"
 text={actionDocumentTreeNodeNameValueData}
/>
<DraftTag
  viewPath={`${viewPath}/DraftTag`}
/>
</div>
<div
  data-testid="Edit.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
</div>
<RegenerateLetterModal
  viewPath={`${viewPath}/RegenerateLetterModal`}
/>
{children}
</React.Fragment>)
}